export const LEAP_DATES = [
  {
    id: 'day1',
    label: 'اليوم 1',
    date: '2026-08-31',
    displayDate: '31 أغسطس',
    title: 'T2 + الاتفاقيات + IBM وOracle',
    priority: 5,
    objective: 'اتفاقية T2 (12:30–1:10) ← Huawei وMicrosoft ← IBM وOracle',
  },
  {
    id: 'day2',
    label: 'اليوم 2',
    date: '2026-09-01',
    displayDate: '1 سبتمبر',
    title: 'The Garage + ELM + Nutanix + حاسب + Zain + TAMKEEN',
    priority: 5,
    objective: 'زيارات شركات ← Nutanix (2:30 م) ← توقيع اتفاقية حاسب (3:30 م) ← Zain ← TAMKEEN',
  },
  {
    id: 'day3',
    label: 'اليوم 3',
    date: '2026-09-02',
    displayDate: '2 سبتمبر',
    title: 'جلسات + Ejada وDevoteam وNVIDIA',
    priority: 3,
    objective: 'يوم الجلسات ← 3 زيارات خفيفة بين المحاضرات',
  },
  {
    id: 'day4',
    label: 'اليوم 4',
    date: '2026-09-03',
    displayDate: '3 سبتمبر',
    title: 'Nokia + Alanafitha + Salesforce',
    priority: 2,
    objective: '3 زيارات أخيرة ← متابعات ← جلسات ختامية (اختياري)',
  },
];

/** 12 company visits across 4 days — max 3 per day, relaxed timing */
export const SCHEDULE = {
  day1: [
    { time: '12:00', endTime: '12:30', title: 'الوصول + التسجيل', type: 'logistics', location: 'المدخل الرئيسي', notes: 'استلام البطاقات، فتح تطبيق LEAP، تأكيد مواقع T2 وHuawei وMicrosoft، توزيع أدوار الفريق.' },
    { time: '12:30', endTime: '13:10', title: 'اتفاقية T2', type: 'agreement', location: 'T2', fixed: true, notes: 'موعد ثابت (12:30 – 1:10).' },
    { time: '13:10', endTime: '14:00', title: 'استراحة + التوجه إلى Huawei', type: 'logistics' },
    { time: '14:00', endTime: '14:30', title: 'اتفاقية Huawei', type: 'agreement', location: 'جناح Huawei', fixed: true, notes: 'موعد ثابت.' },
    { time: '14:30', endTime: '15:00', title: 'استراحة', type: 'break' },
    { time: '15:00', endTime: '15:30', title: 'اتفاقية Microsoft', type: 'agreement', location: 'جناح Microsoft', fixed: true, notes: 'موعد ثابت.' },
    { time: '15:30', endTime: '16:30', title: 'وقت مفتوح / تواصل', type: 'networking', optional: true, notes: 'راجع اللقاءات أو زُر أجنحة من قائمة الزيارات الموصى بها.' },
    { time: '16:30', endTime: '17:15', title: 'IBM Middle East FZ-LLC, Saudi Arabia Branch', type: 'company', location: 'القاعة H1 · الجناح C50', notes: 'هدف الزيارة: AI Agents وأتمتة العمليات وحالات الاستخدام وإمكانية تنفيذ PoC.' },
    { time: '17:15', endTime: '17:30', title: 'استراحة + التنقل', type: 'break' },
    { time: '17:30', endTime: '18:15', title: 'Oracle Systems Limited Saudi Arabia Branch Office', type: 'company', location: 'القاعة H1 · الجناح K40', notes: 'هدف الزيارة: AI والـCloud والبيانات وحالات الاستخدام الممكن تطبيقها في الجامعة.' },
    { time: '18:30', endTime: '19:00', title: 'استراحة العشاء', type: 'break' },
    { time: '18:55', endTime: '19:30', title: 'الثقة الرقمية كبنية وطنية', type: 'session', location: 'World Tech Stage، Hall 3', highlight: true, optional: true, notes: 'جلسة موصى بها — 98% تطابق.' },
    { time: '19:30', endTime: '20:30', title: 'تواصل حر', type: 'networking', optional: true },
  ],
  day2: [
    { time: '12:00', endTime: '12:30', title: 'الوصول', type: 'logistics' },
    { time: '12:30', endTime: '13:00', title: 'استعداد / تواصل حر', type: 'networking', optional: true },
    { time: '13:00', endTime: '13:45', title: 'The Garage', type: 'company', location: 'القاعة H1A · الجناح E90', notes: 'هدف الزيارة: الاطلاع على تجربتهم في بناء البيئة الابتكارية وبرامج الابتكار ودعم المشاريع والشركات الناشئة.' },
    { time: '13:45', endTime: '14:00', title: 'استراحة', type: 'break' },
    { time: '14:00', endTime: '14:30', title: 'ELM Company', type: 'company', location: 'القاعة H1 · الجناح K90', notes: 'هدف الزيارة: الاطلاع على حالات الاستخدام الحكومية في AI والتقنيات الناشئة وفرص تطبيقها في الجامعة.' },
    { time: '14:30', endTime: '15:00', title: 'Nutanix', type: 'company', location: 'Nutanix', fixed: true, notes: 'الثلاثاء 1 سبتمبر 2026 · الساعة 2:30 مساءً · موعد ثابت.' },
    { time: '15:00', endTime: '15:25', title: 'استراحة + التوجه إلى حاسب', type: 'break' },
    { time: '15:30', endTime: '16:00', title: 'توقيع اتفاقية حاسب', type: 'agreement', location: 'جناح شركة حاسب · Hall 1 / E30', fixed: true, notes: 'الثلاثاء 1 سبتمبر 2026 · الساعة 3:30 مساءً · موعد ثابت.' },
    { time: '16:00', endTime: '16:15', title: 'استراحة + التوجه إلى Zain', type: 'break' },
    { time: '16:15', endTime: '16:45', title: 'اتفاقية Zain', type: 'agreement', location: 'جناح Zain', fixed: true, notes: 'موعد ثابت — بعد توقيع حاسب.' },
    { time: '16:15', endTime: '17:00', title: 'استراحة', type: 'break' },
    { time: '17:00', endTime: '17:45', title: 'TAMKEEN Technologies', type: 'company', location: 'القاعة H1 · الجناح A70', notes: 'هدف الزيارة: الاطلاع على تجاربهم في التحول الرقمي والحلول الابتكارية وحالات الاستخدام الحكومية.' },
    { time: '17:40', endTime: '18:10', title: 'مستقبل التعلم الذكي: EdTech', type: 'session', location: 'Code Stage، Hall 1A', highlight: true, optional: true, notes: 'جلسة موصى بها — 100% تطابق.' },
    { time: '18:10', endTime: '19:00', title: 'تواصل حر', type: 'networking', optional: true },
  ],
  day3: [
    { time: '12:00', endTime: '12:30', title: 'الوصول', type: 'logistics', notes: 'يوم مركّز على الجلسات — 3 زيارات فقط بين المحاضرات.' },
    { time: '12:30', endTime: '13:00', title: 'وقت مفتوح', type: 'networking', optional: true },
    { time: '13:00', endTime: '13:45', title: 'Ejada Systems Company', type: 'company', location: 'القاعة H2 · الجناح K10', notes: 'هدف الزيارة: التحول الرقمي والبيانات والـAI وتكامل الأنظمة والحلول الممكن الاستفادة منها في الجامعة.' },
    { time: '13:45', endTime: '14:00', title: 'استراحة', type: 'break' },
    { time: '14:00', endTime: '14:45', title: 'Devoteam Saudi Arabia Co. Ltd', type: 'company', location: 'القاعة H2 · الجناح M20', notes: 'هدف الزيارة: AI Transformation وتقييم النضج وتحويل الـPoC والمبادرات إلى مشاريع فعلية.' },
    { time: '14:45', endTime: '15:15', title: 'استراحة + الانتقال للجلسة', type: 'break' },
    { time: '15:15', endTime: '16:15', title: 'رأس المال البشري المستقبلي', type: 'session', location: 'يُحدد لاحقاً', highlight: true, optional: true, notes: '97% تطابق.' },
    { time: '16:15', endTime: '16:40', title: 'استراحة', type: 'break' },
    { time: '16:40', endTime: '17:30', title: 'الابتكار يبدأ في الحرم الجامعي', type: 'session', location: 'يُحدد لاحقاً', highlight: true, optional: true, notes: '100% تطابق — ذو صلة بوفد جامعة بيشة.' },
    { time: '17:30', endTime: '18:00', title: 'استراحة', type: 'break' },
    { time: '18:00', endTime: '18:45', title: 'NVIDIA', type: 'company', location: 'القاعة H1 · الجناح K40', notes: 'هدف الزيارة: AI Infrastructure والتقنيات الناشئة وDigital Twins وEdge AI وفرص البحث والتطوير.' },
    { time: '17:40', endTime: '18:10', title: 'تمكين الذكاء الاصطناعي الآمن', type: 'session', location: 'يُحدد لاحقاً', highlight: true, optional: true, notes: '95% تطابق — اختياري إذا تعارض مع NVIDIA.' },
    { time: '18:10', endTime: '19:00', title: 'تواصل / الختام', type: 'networking', optional: true },
  ],
  day4: [
    { time: '12:00', endTime: '12:30', title: 'الوصول', type: 'logistics', notes: 'يوم المتابعات والزيارات الأخيرة.' },
    { time: '12:30', endTime: '13:00', title: 'وقت مفتوح', type: 'networking', optional: true },
    { time: '13:00', endTime: '13:45', title: 'Nokia Arabia Limited', type: 'company', location: 'القاعة H1 · الجناح K50', notes: 'هدف الزيارة: Smart Campus و5G وIoT وEdge واستكشاف تطبيقاتها داخل الجامعة.' },
    { time: '13:45', endTime: '14:00', title: 'استراحة', type: 'break' },
    { time: '14:00', endTime: '14:45', title: 'Alanafitha IT VEEAM Booth', type: 'company', location: 'القاعة H2 · الجناح L40', notes: 'هدف الزيارة: الحلول التقنية والتحول الرقمي والحوكمة والبنية التقنية وتجاربهم مع الجهات الحكومية.' },
    { time: '14:45', endTime: '15:00', title: 'استراحة', type: 'break' },
    { time: '15:00', endTime: '15:45', title: 'Salesforce', type: 'company', location: 'H1 · C70', notes: 'CRM مدعوم بالذكاء الاصطناعي. اسأل عن Agentic AI وتكامل LLM وAPIs.' },
    { time: '15:45', endTime: '16:30', title: 'متابعات / زيارات موصى بها', type: 'networking', optional: true, notes: 'زُر أي شركة من قائمة الزيارات الموصى بها أو أكّد اجتماعات المتابعة.' },
    { time: '16:30', endTime: '17:10', title: 'من سيكون جاهزاً لاقتصاد الذكاء الاصطناعي؟', type: 'session', location: 'DeepFest، Hall 5', highlight: true, optional: true },
    { time: '17:10', endTime: '19:00', title: 'مفتوح — أجنحة متبقية / مغادرة', type: 'logistics', optional: true, notes: 'ساعات LEAP: 12:00 م – 9:00 م.' },
  ],
};

/** Companies to visit when time allows — not tightly scheduled */
export const RECOMMENDED_VISITS = [
  {
    name: 'vminds.ai',
    location: 'H1A · P123',
    notes: 'Agentic AI / multimodal AI. اسأل عن LLMs والوكلاء وRAG والنشر المؤسسي — زُرها إن توفر وقت في اليوم 1.',
    suggestedDay: 'اليوم 1',
  },
  {
    name: 'AILA (Moudarres Al Aftaradi)',
    location: 'H1A · P379',
    notes: 'تعلم شخصي مدعوم بالذكاء الاصطناعي وسير عمل تعليمي ذكي.',
    suggestedDay: 'اليوم 1',
  },
  {
    name: 'Naseej',
    location: 'H2 · R41',
    notes: 'Cloud SaaS، أتمتة مدعومة بالذكاء الاصطناعي، أتمتة سير العمل، حلول تجربة الطالب.',
    suggestedDay: 'اليوم 2',
  },
  {
    name: 'CrowdStrike',
    location: 'يُحدد في المعرض',
    notes: 'منصة أمن سيبراني AI-native — تطابق 96%.',
    suggestedDay: 'اليوم 4',
  },
  {
    name: 'Nourah IT',
    location: 'يُحدد في المعرض',
    notes: 'بنية تحتية AI-ready — تطابق 95%.',
    suggestedDay: 'اليوم 4',
  },
];

export const TYPE_LABELS = {
  agreement: 'اتفاقية',
  company: 'زيارة شركة',
  session: 'جلسة',
  break: 'استراحة',
  networking: 'تواصل',
  logistics: 'تنظيم',
};

export const SCHEDULE_SUMMARY = {
  maxCompanies: 12,
  companiesPerDay: 3,
  totalRecommended: RECOMMENDED_VISITS.length,
};
